import React from 'react';
import Head from 'next/head';
import { Hero, Card, ComponentVerticalSpacing, ComponentWrapper } from 'day8-react/build/new-components';
import PageLayout from '../layouts/page';

const Press = () => (
  <PageLayout page={{ seo_title: 'Press | The Ski Week' }}>
    <Head>
      <title>Press</title>
    </Head>
    <Hero bgImage={{ url: "https://cdn.theyachtweek.com/tsw/tsw_press_header.jpg", alt: "press" }} title="Press" whiteFont />
    <ComponentVerticalSpacing>
      <ComponentWrapper>
        <div className="d8-l-3-col-grid">
          <Card
            template="ImageCard"
            imageCardTemplate="VerticalSplit"
            subheading="Ski Destinations For All Levels (From Nube To Expert)"
            image={{ url: "https://cdn.theyachtweek.com/tsw/suitcase.jpg", alt: "suitcase" }}
            cta={{
              text: 'Learn More',
              link: "https://suitcasemag.com/travel/stories/ski-destinations-for-all-levels/",
              buttonType: "btn--bare",
              icon: "arrow-right",
              iconFlip: true
            }}
          />
          <Card
            template="ImageCard"
            imageCardTemplate="VerticalSplit"
            subheading="7 Holidays You Need To Book Right Now"
            image={{ url: "https://cdn.theyachtweek.com/tsw/refinery.jpg", alt: "refinery" }}
            cta={{
              text: 'Learn More',
              link: "https://cdn.theyachtweek.com/tsw/Holiday%20Destinations%202016.pdf",
              buttonType: "btn--bare",
              icon: "arrow-right",
              iconFlip: true
            }}
          />
          <Card
            template="ImageCard"
            imageCardTemplate="VerticalSplit"
            subheading="Definitive selection on piste and off"
            image={{ url: "https://cdn.theyachtweek.com/tsw/telegraph.jpg", alt: "refinery" }}
            cta={{
              text: 'Learn More',
              link: "https://cdn.theyachtweek.com/tsw/Telegraph%20Ski%20and%20Snowboard.pdf",
              buttonType: "btn--bare",
              icon: "arrow-right",
              iconFlip: true
            }}
          />
          <Card
            template="ImageCard"
            imageCardTemplate="VerticalSplit"
            subheading="The Ski Week 2014"
            image={{ url: "https://cdn.theyachtweek.com/tsw/suitcase.jpg", alt: "suitcase" }}
            cta={{
              text: 'Learn More',
              link: "https://cdn.theyachtweek.com/tsw/Suitcase%20-%20The%20Ski%20Week.pdf",
              buttonType: "btn--bare",
              icon: "arrow-right",
              iconFlip: true
            }}
          />
          <Card
            template="ImageCard"
            imageCardTemplate="VerticalSplit"
            subheading="Just How Outdoorsy Is London?"
            image={{ url: "https://cdn.theyachtweek.com/tsw/huffpost.jpg", alt: "huffpost" }}
            cta={{
              text: 'Learn More',
              link: "https://cdn.theyachtweek.com/tsw/huffpost.pdf",
              buttonType: "btn--bare",
              icon: "arrow-right",
              iconFlip: true
            }}
          />
        </div>
      </ComponentWrapper>
    </ComponentVerticalSpacing>
  </PageLayout>
);
export default Press;
